import { Breadcrumbs, Typography } from '@mui/material'
import { Archive, Home, Server, Settings } from 'react-feather'
import { useNavigate } from 'react-router-dom'
import { breadCrumbStyles, campaignsBreadCrumbStyle, locationBreadCrumbStyle } from './BreadCrumb.styles'
import { useTheme } from '@mui/material/styles'
import { CAMPAIGN_MANAGER_PATH } from '../../routes/CampaignManagerRoutes'

type BreadCrumbProps = {
	pathname: string
	location?: string
}

export const BreadCrumb = ({ pathname, location }: BreadCrumbProps) => {
	const navigate = useNavigate()
	const { palette } = useTheme()

	switch (pathname) {
		case '/home':
			return (
				<Breadcrumbs aria-label="breadcrumb" sx={{ px: '48px' }}>
					<div style={breadCrumbStyles(palette)}>
						<Home /> Home
					</div>
					<Typography sx={{ color: 'text.primary' }}></Typography>
				</Breadcrumbs>
			)
		case '/details':
			return (
				<Breadcrumbs aria-label="breadcrumb" sx={{ px: '48px' }}>
					<div onClick={() => navigate(CAMPAIGN_MANAGER_PATH)} style={campaignsBreadCrumbStyle(palette)}>
						<Server /> Campaigns
					</div>
					{location && (
						<div style={locationBreadCrumbStyle(palette)}>
							<Archive /> {location}
						</div>
					)}
				</Breadcrumbs>
			)
		case '/settings':
			return (
				<Breadcrumbs aria-label="breadcrumb" sx={{ px: '48px' }}>
					<div style={breadCrumbStyles(palette)}>
						<Settings /> Settings
					</div>
				</Breadcrumbs>
			)
	}
}
